import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { currentUser, userData, loading } = useAuth();

  if (loading) return null;

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!userData) return null;

  if (allowedRoles && !allowedRoles.includes(userData.role)) {
    return <Navigate to="/" replace />;
  }

  // 🔒 Tutors must be approved to access the dashboard
  if (userData.role === "tutor" && userData.status !== "approved") {
    return <Navigate to="/pending" replace />;
  }

  return children;
}